import { useEffect, useState } from "react";
import moment from "moment";
import { Swiper, SwiperSlide } from "swiper/react";
import { useMediaQuery } from "react-responsive";

import { fetchRecommendJobPostings } from "api/jobPosting/rests";
import { IJobOpeningOverview } from "api/jobPosting/types";
import { JOBPOSTING_PATH } from "routes";

const RecommendRecruitList = () => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const [jobPostings, setJobPostings] = useState<IJobOpeningOverview[]>([]);

  useEffect(() => {
    (async () => {
      const { data } = await fetchRecommendJobPostings();
      setJobPostings(data);
    })();
  }, []);

  return (
    <div className="announcement-form">
      <div className="announcement-item-list">
        <div className="swiper-button-next recommend-recruit-swiper-button-next"></div>
        <div className="swiper-container">
          {jobPostings.length > 0 && (
            <Swiper
              wrapperTag="ul"
              autoplay={true}
              loop={true}
              spaceBetween={isTabletOrMobile ? 10 : 20}
              slidesPerView={isTabletOrMobile ? 2 : 4}
              navigation={{ nextEl: ".recommend-recruit-swiper-button-next" }}
            >
              <ul className="swiper-wrapper">
                {jobPostings.map((jobPosting, i) => (
                  <SwiperSlide tag="li" className="swiper-slide" key={i}>
                    <a
                      href={`${JOBPOSTING_PATH}/${jobPosting.job_id}`}
                      className="item-box"
                    >
                      <div className="top-box">
                        <div className="label-box">
                          <div className="label-txt">추천</div>
                        </div>
                        <div className="subject-box">{jobPosting.title}</div>
                      </div>

                      <div className="bottom-box">
                        <div className="day-box">
                          <i className="ic ic-day"></i>
                          <span className="txt">
                            D-
                            {moment(jobPosting.closing_date).diff(
                              moment(),
                              "days"
                            )}
                          </span>
                        </div>
                        <div className="corp-box">{jobPosting.clinic_name}</div>
                        <div className="region-box">{jobPosting.city}</div>
                      </div>
                    </a>
                  </SwiperSlide>
                ))}
              </ul>
            </Swiper>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecommendRecruitList;
